import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

const ROUTE_LABELS: Record<string, string> = {
  "": "Home",
  search: "Search",
  stock: "Analysis",
  watchlist: "Watchlist",
  plans: "Plans",
  billing: "Billing",
  profile: "Profile",
  admin: "Admin",
  wallet: "Growth Plan",
  "daily-tips": "Daily Tips",
  "active-tips": "History Tips",
  "expired-tips": "Expired Tips",
  "tips-analysis": "Tips Analysis",
  "deleted-tips": "Deleted Tips",
  "add-tip": "Add Tip",
  "trading-wallet": "Wallet",
  "my-trades": "My Trades",
};

const Breadcrumb: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const segments = location.pathname.split("/").filter(Boolean);

  // Don't show on login/signup/reset pages
  if (["/login", "/signup", "/reset-password"].includes(location.pathname)) return null;

  const crumbs: { label: string; path: string }[] = [{ label: "Home", path: "/" }];

  segments.forEach((seg, i) => {
    const path = "/" + segments.slice(0, i + 1).join("/");
    const label = ROUTE_LABELS[seg] || decodeURIComponent(seg);
    crumbs.push({ label, path });
  });

  if (crumbs.length <= 1) return null;

  return (
    <nav className="container max-w-3xl mx-auto px-4 pt-4 pb-0">
      <ol className="flex items-center gap-1.5 text-sm text-muted-foreground flex-wrap">
        {crumbs.map((crumb, i) => {
          const isLast = i === crumbs.length - 1;
          return (
            <li key={crumb.path} className="flex items-center gap-1.5">
              {i > 0 && <ChevronRight className="h-3.5 w-3.5 shrink-0" />}
              {isLast ? (
                <span className="font-medium text-foreground flex items-center gap-1">
                  {i === 0 && <Home className="h-3 w-3" />}
                  {crumb.label}
                </span>
              ) : (
                <button
                  onClick={() => navigate(crumb.path)}
                  className="hover:text-foreground transition-colors flex items-center gap-1"
                >
                  {i === 0 && <Home className="h-3 w-3" />}
                  {crumb.label}
                </button>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
